import React, { useEffect } from 'react';
import TacticalServiceHero from '../components/Tactical/TacticalServiceHero';
import TacticalServices from '../components/Tactical/TacticalServices';
import ContactSection from '../components/layout/ContactSection';
import Footer from '../components/layout/footer';

const Tactical = () => {

  useEffect(() => {
    const handleContextMenu = (e) => e.preventDefault();

    const handleKeyDown = (e) => {
      if (
        e.keyCode === 123 || // F12
        (e.ctrlKey && e.shiftKey && (e.keyCode === 73 || e.keyCode === 74)) || // Ctrl+Shift+I / J
        (e.ctrlKey && e.keyCode === 85) // Ctrl+U
      ) {
        e.preventDefault();
      }
    };

    document.addEventListener("contextmenu", handleContextMenu);
    document.addEventListener("keydown", handleKeyDown);

    return () => {
      document.removeEventListener("contextmenu", handleContextMenu);
      document.removeEventListener("keydown", handleKeyDown);
    };
  }, []);

  return (
    <div className="min-h-screen text-white pt-2">
        <section id="TacticalServiceHero" className="scroll-mt-24">
            <TacticalServiceHero />
        </section>

        <section id="TacticalServices" className="scroll-mt-24">
            <TacticalServices />
        </section>

        <section id="contact-us">
          <ContactSection />
        </section>

        <section id="Footer">
            <Footer />
        </section>
        
    </div>
  );
};

export default Tactical;